// extracted by mini-css-extract-plugin
export default {"card":"DropDown_card__dH9Np","card-body":"DropDown_card-body__u5+oR","userImg":"DropDown_userImg__ZR0kd"};